import { staffTypes } from "./../../types/userTypes";
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  Inject,
  Optional,
  OnInit
} from "@angular/core";
import {
  UntypedFormGroup,
  FormControl,
  UntypedFormBuilder,
  ReactiveFormsModule,
  Validators,
  FormsModule
} from "@angular/forms";
import { CoreService } from "../../services/coreService";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Observable, from, of } from "rxjs";
import { CountryCodeDetails } from "../../types/country-codes.model";
import { map, tap } from "rxjs/operators";
import { DiscountService } from "../../body/discount/services/discount.service";
import { CommonModule } from "@angular/common";
import { TimepickerModule } from "ngx-bootstrap/timepicker";

declare let toastr: any;

@Component({
    selector: 'app-add-vallet-staff-modal',
    templateUrl: './add-vallet-staff-modal.component.html',
    styleUrls: ['./add-vallet-staff-modal.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, TimepickerModule, ReactiveFormsModule]
})
export class AddValletStaffModalComponent implements OnChanges, OnInit {
  staffs: any;
  form: UntypedFormGroup;
  isSubmitted = false;
  parking_places$:Observable<any>;
  countryCodes$:Observable<CountryCodeDetails[]>
  @Input() parkingID = null;
  @Output() close = new EventEmitter();
  @Output() createStaff = new EventEmitter<any>();
  @Output() editStaff = new EventEmitter<any>(); 
  constructor(
    private builder: UntypedFormBuilder,
    private coreService: CoreService,
    public dialogRef: MatDialogRef<AddValletStaffModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private discountService:DiscountService
  ) {    
    this.staffs= this.data.staff;
    this.parkingID = this.data.parkingID;
    this.form = this.builder.group({
      id: [""],
      valet_site_id: [this.parkingID, Validators.required],
      first_name: ["", Validators.required],
      last_name: ["", Validators.required],
      email: ["", Validators.compose([
        Validators.required,
        Validators.pattern(/^[a-z]+[a-z0-9._]+@[a-z]+\.[a-z.]{2,5}$/)
      ])],
      country_code: ['',Validators.compose([Validators.required])],
      mobileno: [
        "",
        Validators.compose([
          Validators.required

        ])
      ],
      user_type: ["", Validators.required],
      password: ["123456789"
        ,
        Validators.compose([Validators.required, Validators.minLength(8)])
      ],
      shift_start_time:["",Validators.required],
      shift_end_time:["",Validators.required],
      shift:true,
    });

    if(this.staffs){
      this.form.patchValue({
        id:this.staffs.id,
        valet_site_id: this.parkingID,
        first_name: this.staffs.first_name,
        last_name: this.staffs.last_name,
        email: this.staffs.email,
        country_code: this.staffs.countrycode,
        mobileno: this.staffs.mobile_no,
        user_type: this.staffs.user_type,
        password: "123456789",
        shift_start_time: new Date("01/01/1900 " + this.staffs.shifts_data.shift_start_time),
        shift_end_time: new Date("01/01/1900 " + this.staffs.shifts_data.shift_end_time),
        shift: this.staffs.shifts_data.is_active
      });      
    }
  }

  closeModal() {
    this.resetModal();
    this.close.emit();
    this.dialogRef.close(null);
  }

  resetModal() {
    this.form.reset();
    this.form.patchValue({
      parking_place_id: this.parkingID,
      first_name: "",
      last_name: "",
      email: "",
      mobileno: "",
      user_type: "",
      password: ""
    });
    this.isSubmitted = false;
  }

  submitForm() {    
    this.isSubmitted = true;    
    if (this.form.valid) {  
      this.form.patchValue({
      shift_start_time : this.form.value.shift_start_time.toTimeString().split(' ')[0],
      shift_end_time : this.form.value.shift_end_time.toTimeString().split(' ')[0]
      });
      if(this.staffs){
      this.editStaff.emit(this.form.value);
      }
      else{
        this.createStaff.emit(this.form.value);
      }
      this.dialogRef.close(this.form.value);
      this.resetModal();
    } else {
      toastr.error("", "Form is invalid.", {
        timeOut: 2000
      });
    }
  }

  ngOnInit() {
    try {  
      this.countryCodes$ = this.coreService.GetCountryCodesList();
      this.parking_places$ = this.discountService.getParkingPlaces().pipe(map((res:any)=>res.data));
    } catch (error) {
      toastr.error("", "Failed to fetch user types.", {
        timeOut: 2000
      });
      this.closeModal();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes.parkingID.currentValue != null) {
    //   this.resetModal();
    // }
  }
}
